module.exports = __webpack_public_path__ + "img/vrPanorams-solution-warp3-img1.ea6adae0.png";